// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__RuCX5","title":"ClientReferral_title__1yU3N","itemText":"ClientReferral_itemText__rXxDd"};